export default __webpack_public_path__ + "static/media/wavingHand.2f5f0e5b.svg";